class OuttraMap {
    constructor ($outtraIframe) {
        this.$outtraIframe = $outtraIframe;
    }

    initialize () {
        const waitForConsent = setInterval(() => {
            if (typeof CookieConsent !== 'undefined') {
                clearInterval(waitForConsent);
                if (CookieConsent.consent.preferences === true) { // eslint-disable-line
                    this.$outtraIframe.src = this.$outtraIframe.dataset.outtraMapSrc;

                    const $placeholder = this.$outtraIframe.parentElement.querySelector('.media__restriction');

                    if ($placeholder) {
                        $placeholder.remove();
                    }
                } else {
                    const $placeholder = this.$outtraIframe.parentElement.querySelector('.media__restriction');

                    if ($placeholder) {
                        $placeholder.classList.add('is--shown');
                    }
                }
            } else {
                console.log('waiting for CookieContent');
            }
        }, 300);

        // timout if cookie consent is not defined - to prevent a permanent loop in the terminal
        setTimeout(() => {
            clearInterval(waitForConsent);
        }, 10000);
    }
}

export { OuttraMap };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$outtraMap = $context.querySelectorAll('[data-outtra-map-src]');

        if ($$outtraMap.length > 0) {
            $$outtraMap.forEach($outtraMap => {
                const outtraMap = new OuttraMap($outtraMap);
                outtraMap.initialize();
            });
        }
    }
});
